import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { HttpService } from '../../shared/services/http.service';

@Injectable({ providedIn: 'root' })
export class HttpStatsService {
    constructor(private httpService: HttpService) {}

    updateSitesStats(count: number): Promise<void> {
        return firstValueFrom(
            this.httpService.post(`/v1/stats`, {
                sites: count,
                sites_servego: count,
            }),
        );
    }
}
